exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background:#4c5a55;color:#fff;font-family:Montserrat,sans-serif}body .Wrapper{padding-bottom:100px}body .btn__cta{background:#fff;color:#4c5a55;border-radius:50px;font-weight:700;font-size:16px;padding:15px 40px;box-shadow:0 2px 4px rgba(0,0,0,.25)}body .btn__cta:hover{box-shadow:0 -1px 5px rgba(0,0,0,.5)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/App.less
 ** module id = 172
 ** module chunks = 0
 **/